<template>
  <div>
    <Swiper :cateID="40"></Swiper>
    <div class="common_frame first_frame clearfix">
      <!-- 产品中心 -->
      <div class="first_product">
        <div class="first_title actives">直线电机模组</div>
        <div class="f16 first_describe">
          <!-- 飞创直线模组为液晶屏搬运（TFT、LED、OLED、AMOLED），半导体制造（晶圆检测、IC阵列封装和检测、切割），汽车零部件组装，曲线点胶，激光切割，3D打印，零部件平面度，轮廓检测，多工位装配等领域提供直驱运动解决方案！ -->
          <img
            src="../../../static/img/common/tab.jpg"
            style="width: 100%; margin: 30px 0"
            alt=""
          />
        </div>
        <div
          v-for="(item, indexs) in datalist"
          :key="indexs"
          class="first_product_list cursor"
          v-if="indexs < 4"
          @click="to_detail(item.goods_id)"
        >
          <div class="first_product_every">
            <div class="f16 cb bold overflow2">{{ item.goods_name }}</div>
            <img :src="item.thumbnail" alt="" class="img" />
            <div v-for="items in item.goods_info" class="f14 c00">
              {{ items }}
            </div>
            <!-- <div class="f14 first_comm overflow2">
              {{ item.desc }}
            </div> -->
            <!-- <button class="btn f16 cursor">了解详情</button> -->
            <div data-v-6ab21c4f="" class="f16 cb line_understand">
              了解详情⇀
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <button class="first_more cursor" @click="to_more">MORE >></button>
        <!-- <div style='width:100%;text-align:center'> -->

        <!-- </div> -->
      </div>
      <!-- 直线模组 -->
      <div class="first_line">
        <div class="first_title actives">选型计算</div>
        <div class="f16 first_describe">
          直驱在线APP是一款国内首创、技术领先的模组选型软件。用户可根据所属行业、使用环境、运动状态、安装方式等快速精准的完成最佳选型计算方案，一键生成PDF方案图纸。
        </div>
        <div :class="type == 'no' ? 'first_images' : 'first_number'">
          <!-- <img
            src="../../../static/img/common/play.png"
            alt=""
            class="common_play"
            v-if="type == 'no'"
            @click="tabs"
          /> -->
          <div class="home_icons cursor" @click.stop="to_type">
            <p class="pb">选型计算</p>
            <p class="ps">
              <img
                src="../../../static/img/common/rights.png"
                class="img"
                alt=""
              />
            </p>
          </div>
          <!-- <video
            src="https://app.faster-motion.com/uploads/20210223/96b223acca86a7a40e4dfbbe1b860bbb.mp4"
            type="video/mp4"
            muted="muted"
            controls="controls"
            v-if="type == 'yes'"
            :autoplay="type == 'yes'"
          ></video> -->
        </div>
      </div>
      <!-- 新闻中心 -->
      <div class="first_news">
        <div class="first_title actives">新闻中心</div>
        <div class="f16 first_describe">
          自动化领域技术动态及直驱（直线）电机模组行业应用，聚焦行业热点，技术专题。
        </div>
        <div class="first_news_tab">
          <button
            v-for="(item, oindex) in newsList"
            @click="checkTab(item.id, oindex)"
            :class="oindex == actives ? 'oactives' : ''"
          >
            {{ item.name }}
          </button>
        </div>
        <div class="first_news_detail" v-if="Listnews != ''">
          <div
            v-for="(item, indexs) in Listnews"
            :key="indexs"
            class="first_news_every cursor"
            v-if="indexs < 4"
            @click="newsdetail(item.art_id)"
          >
            <img :src="item.thumbnail[0]" class="img" alt="" />
            <div class="first_news_right">
              <div class="f18 bold c34 fonts" style="height: 50px">
                {{ item.title }}
              </div>
              <div class="f14 cg">{{ item.create_time | timeFormate }}</div>
              <div class="first_hr hr_active"></div>
              <div class="f16 overflow2 cgray">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 200px; text-align: center" v-else>
          <div class="cg f20">暂无内容</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, getToken } from "@/utils/auth";
import { goodsList, columnlist } from "@/api/api";
export default {
  name: "first",
  data() {
    return {
      datalist: [],
      newsList: "",
      Listnews: [],
      actives: "",
      offset: 0,
      limit: 10,
      type: "no",
      getToken: "",
    };
  },
  created() {
    this.$store.commit("actives", "首页");
    // 禁用右键
    document.oncontextmenu = new Function("event.returnValue=false");
    // 禁用选择
    document.onselectstart = new Function("event.returnValue=false");
  },
  components: {
    Swiper: () => import("../Module1/Swiper.vue"),
  },
  mounted() {
    this.goodlist();
    this.columnList();
    this.getToken = getToken();
  },
  filters: {
    timeFormate: function (str) {
      return str.slice(0, 10);
    },
  },
  activated() {
    this.goodlist();
    this.columnList();
    this.getToken = getToken();
  },
  methods: {
    //产品列表
    goodlist() {
      goodsList({ action: "list" }).then(
        (res) => {
          if ((res.data.code = 1)) {
            this.datalist = res.data.data;
            for (let index = 0; index < this.datalist.length; index++) {
              if (
                res.data.data[index].goods_info != "" &&
                res.data.data[index].goods_info != null
              ) {
                this.datalist[index].goods_info =
                  res.data.data[index].goods_info.split("\r\n");
              }
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //新闻栏目列表
    columnList() {
      columnlist({ action: "column" }).then(
        (res) => {
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].id == 41) {
              this.newsList = res.data.data[i].child[0];
              this.checkTab("newsall");
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //切换新闻类型
    checkTab(id, index) {
      this.actives = index;
      let params = {
        action: "art",
        column_id: id,
        offset: this.offset,
        limit: this.limit,
      };
      columnlist(params).then(
        (res) => {
          this.Listnews = [];
          if (res.data.data.top != "") {
            for (var i = 0; i < res.data.data.top.length; i++) {
              this.Listnews.push(res.data.data.top[i]);
            }
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.Listnews.push(res.data.data.list[i]);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    //去新闻详情
    newsdetail(id) {
      this.$router.push({ name: "NewsDetail", query: { id: id } });
    },
    //去产品详情
    to_detail(id) {
      this.$router.push({ name: "ProductDetail", query: { lid: id } });
    },
    //去产品列表==》直线模组
    to_more() {
      this.$router.push({ name: "LineCenter", query: { oid: 81 } });
    },
    tabs() {
      this.type = "yes";
    },
    //去选型
    to_type() {
      this.$router.push({ name: "LectoType" });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "../../../static/css/common.scss";
.home_frame {
  width: 100%;
  height: 1000px;
}
.swiper-container {
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
    background: $white;
  }
}
.first_frame {
  width: 100%;
  box-sizing: border-box;
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;
  .first_product_list {
    width: 23%;
    float: left;
    margin-right: 20px;
    border: 1px solid #f0f0f0;
    margin-top: 50px;
    text-align: left;
  }
  .first_product_list:hover {
    border: 1px solid #2ab8fe;
    box-shadow: 0px 0px 98px 0px rgba(44, 44, 44, 0.1);
  }
  .first_describe {
    color: #333333;
    width: 100%;
    text-align: center;
    line-height: 30px;
  }
  .img {
    width: 100%;
    height: 200px;
  }
  .first_product_every {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 15px 25px 25px 20px;
    & > div:nth-of-type(1) {
      height: 40px;
    }
  }
  .first_comm {
    color: $gray;
    margin-top: 15px;
    line-height: 20px;
  }
  .btn {
    width: 110px;
    height: 35px;
    border: 1px solid $blue;
    color: $blue;
    font-size: 16px;
    background: $white;
    margin-top: 30px;
  }
  .first_more {
    width: 289px;
    height: 48px;
    border: 1px solid #a4a4a2;
    color: $gray;
    background: $white;
    margin-top: 50px;
  }
  .first_more:hover {
    color: $blue;
    border: 1px solid $blue;
  }
}
.first_line {
  width: 100%;
  box-sizing: border-box;
  padding: 50px 0px;
  .first_images {
    width: 100%;
    height: 560px;
    background: $gray;
    margin-top: 50px;
    box-sizing: border-box;
    padding: 10px 0px;
    background: url("https://app.faster-motion.com/uploads/20210302/6cbc0138116385d15c6816be7b7b4d7a.png")
      no-repeat;
    background-size: 100% 100%;
    text-align: center;
    video {
      height: 100%;
      width: auto;
      outline: none;
    }
  }
  .first_number {
    width: 100%;
    height: 560px;
    background: $gray;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 10px 0px;
    background: $gray;
    video {
      height: 100%;
      width: auto;
      outline: none;
    }
  }
}
.line_understand {
  width: 100%;
  text-align: right;
  margin-top: 30px;
}
.first_news {
  width: 100%;
  text-align: center;
  .first_news_tab {
    width: 100%;
    margin: 50px 0px;
    button {
      width: 100px;
      height: 30px;
      border: 1px solid $border;
      background: $white;
      color: #333;
      margin-right: 10px;
      cursor: pointer;
    }
    button:hover {
      border: 1px solid white;
      background: $blue;
      color: white;
    }
  }
  .oactives {
    border: 1px solid white !important;
    background: $blue !important;
    color: white !important;
  }
  .first_news_detail {
    width: 100%;
    .first_news_every {
      width: 49%;
      margin-right: 1%;
      float: left;
      margin-bottom: 40px;
      &:hover .fonts {
        color: $blue;
      }
      &:hover .hr_active::before {
        display: block;
      }
      img {
        width: 260px;
        height: 165px;
        float: left;
      }
      .first_news_right {
        width: 50%;
        float: right;
        text-align: left;
        line-height: 25px;
      }
      .first_hr {
        width: 267px;
        height: 3px;
        background: #f4f4f4;
        border-radius: 2px;
        margin: 20px 0px;
        position: relative;
      }
      .hr_active {
        position: relative;
      }
      .hr_active::before {
        content: "";
        width: 34px;
        height: 5px;
        background-color: #2ab7fe;
        position: absolute;
        bottom: -1px;
        left: 0px;
        border-radius: 3px;
        display: none;
      }
    }
  }
}
.home_icons {
  width: 190px;
  height: 50px;
  background: white;
  margin: 0 auto;
  margin-top: 440px;
  p:nth-of-type(1) {
    width: 145px;
    height: 50px;
    line-height: 50px;
    float: left;
    font-size: 16px;
    color: #0061ae;
    text-align: center;
  }
  p:nth-of-type(2) {
    width: 45px;
    height: 50px;
    line-height: 50px;
    background: $blue;
    float: right;
    text-align: center;
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
  }

  p {
    display: inline-block;
  }
}
.home_icons:hover .ps {
  background: rgb(254, 199, 3) !important;
}
.common_play {
  width: 50px !important;
  height: 50px !important;
  margin-top: 250px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Major/first.vue